import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const BusinessFinancialConnectionSchema = z.object({
    id: z.string().optional(),
});

export class BusinessFinancialConnection extends FromSchema(BusinessFinancialConnectionSchema) {
    id?: string;
}
